// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__iZJrC","header":"Layout_header__0xpY9","main":"Layout_main__bsCuA"};